<template>
  <div class="HeaderBar">
    <router-link
      class="title"
      tag="div"
      :to="{ name: 'narrative', query: $route.query }"
    >
      <div>12 Sunsets</div>
    </router-link>
    <div class="subtitle">Exploring Ed Ruscha's Archive</div>
    <div class="navigation">
      <div :class="{ drive: true, active: $route.name === 'map' }">
        <router-link
          :to="{ name: 'map', params: { year: '1985' }, query: $route.query }"
          >Drive</router-link
        >
      </div>
      <div :class="{ sort: true, active: $route.name === 'contact-sheet' }">
        <router-link :to="{ name: 'contact-sheet', query: $route.query }"
          >Sort</router-link
        >
      </div>
      <div :class="{ about: true, active: $route.name === 'about' }">
        <router-link :to="{ name: 'about', query: $route.query }">
          About</router-link
        >
      </div>
      <div
        class="share"
        @click="$store.commit('setShare', !$store.state.ui.share)"
      >
        Share
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderBar"
};
</script>

<style lang="scss" scoped>
@import "@/constants/_variables.scss";

.HeaderBar {
  width: 100%;
  display: flex;
  height: 67px;
  background-color: $very-light-pink;
  align-items: center;
  position: relative;
}

.title {
  font-family: "Graphik";
  font-style: italic;
  font-size: 30px;
  font-weight: 600;
  background-color: $copper;
  color: $very-light-pink;
  text-transform: uppercase;
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 10px;
  position: relative;
  margin-right: 1em;

  &:hover {
    // background-color: $light-gold;
    // color: $copper;
    cursor: pointer;
    color: $light-gold;
  }

  div {
    z-index: 2;
  }
}

.title:after {
  cursor: pointer;
  background: inherit;
  content: "";
  width: 40px;
  height: 100%;
  right: -20px;
  bottom: 0;
  display: block;
  position: absolute;
  transform-origin: 100%;
  transform: skewX(-10deg);
  z-index: 1;
}

.subtitle {
  text-transform: uppercase;
  font-size: 20px;
  font-weight: 300;
}

.navigation {
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  div {
    text-transform: uppercase;
    font-size: 20px;
    font-weight: 300;
    padding-left: 0.5em;
    padding-right: 0.5em;

    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }

    &.share {
      color: $copper;
      font-weight: 700;
      font-style: italic;
      font-size: 23px;
      margin-top: -2px;
    }
  }

  .active {
    font-weight: 500;
    text-decoration: underline;
  }
}

a {
  color: inherit;
  text-decoration: inherit;
}
</style>
